import { render } from "./SubscriptionsListZaymstar.vue?vue&type=template&id=580426d4&scoped=true"
import script from "./SubscriptionsListZaymstar.vue?vue&type=script&lang=js"
export * from "./SubscriptionsListZaymstar.vue?vue&type=script&lang=js"

import "./SubscriptionsListZaymstar.vue?vue&type=style&index=0&id=580426d4&scoped=true&lang=css"
import "./SubscriptionsListZaymstar.vue?vue&type=style&index=1&id=580426d4&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580426d4"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect,QDialog,QCard,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
